import request from "@/plugins/axios/courseApi.js";

export function getCheatInfo (params) {
  return request({
    url: 'textbook/cheatCheck',
    method: 'get',
    params
  })
} 

export function checkLoginName (params) {
  return request({
    url: 'users/check',
    method: 'get',
    params
  })
}

export function getLoginVersion (params) {
  return request({
    url: 'users/loginApi',
    method: 'get',
    params
  })
} 

// 获取图形验证码
export function getImgCode (params) {
  return request({
    url: 'captcha',
    method: 'get',
    params
  })
} 

// 发送手机短信码
export function checkSendsms (data) {
  return request({
    url: 'login/sendsms',
    method: 'post',
    data
  })
} 

// 验证手机短信码是否正确 手机号和验证码
export function checkcode (data) {
  return request({
    url: 'login/checkcode',
    method: 'post',
    data
  })
}


// 验证手机短信码是否正确 loginName和验证码
export function checkcodeByLoginName (params) {
  return request({
    url: 'users/check/securityCode',
    method: 'get',
    params
  })
}

// 获取课程主页基本信息
export function getTextbookInfo (id) {
  return request({
    url: 'homepage/courses/info/' + id,
    method: 'get'
  })
}

// 获取课程主页课程详情和章节目录 homepage/courses/detail/{id}
export function getTextbookDetail (id) {
  return request({
    url: 'homepage/courses/detail/' + id,
    method: 'get'
  })
}

//获取课件开通情况 1已开通  -1未开通  -2已过期
export function getTextbookOpen (id) {
  return request({
    url: 'homepages/textbook/open/' + id,
    method: 'get'
  })
}

// 获取允许外校学生加入的班级 /homepage//termClasses/foreignSchool
export function getTermForeignSchool (params) {
  return request({
    url: 'homepages/termClasses/foreignSchool',
    method: 'get',
    params
  })
}

//外校学生加入班级 /homepages/joinClass/foreignSchool
export function foreignerJoinClass (classId) {
  return request({
    url: 'homepages/joinClass/foreignSchool',
    method: 'get',
    params :{
      classId
    }
  })
}

// 开通课件 /homepages/textbook/open/{textbookId}
export function joinTextbook (id) {
  return request({
    url: 'homepages/textbook/open/' + id,
    method: 'post'
  })
}


// 获取学生在学期的班课id 若result没返回（为null），表示学生不在学期的任意一个班课中
export function getTermOcId (params) {
  return request({
    url: 'homepages/termOcId',
    method: 'get',
    params
  })
}

// 获取班课菜单 https://courseapi.tongshike.cn/ocApps/list?ocId=27162&currentPlatformType=1&lang=zh
export function getCourseMenu (ocId) {
  return request({
    url: 'ocApps/list',
    method: 'get',
    params : {
      currentPlatformType: 1,
      ocId: ocId
    }
  })
}

//退出登录 /users/logout
export function logout () {
  return request({
    url: 'users/logout',
    method: 'post'
  })
}

// 获取申报课程列表 /declarecourse/list
export function getDeclareCourseList (params) {
  return request({
    url: 'declarecourse/list',
    method: 'get',
    params
  })
}

// 获取源课件列表/declarecourse/courselist
export function getDeclareOriginTextbookList (params) {
  return request({
    url: 'declarecourse/courselist',
    method: 'get',
    params
  })
}

// 添加/修改申报课程 /declarecourse
export function saveDeclareCourse (data) {
  return request({
    url: 'declarecourse',
    method: 'post',
    data
  })
}

// 删除申报课程 /declarecourse/{id}
export function deleteDeclareCourse (id) {
  return request({
    url: 'declarecourse/' + id,
    method: 'delete'
  })
}

 // 获取申报课程详情 /declarecourse/{id}
 export function getDeclareCourseInfo (id) {
  return request({
    url: 'declarecourse/' + id,
    method: 'get'
  })
}

//获取课件版本列表 /declarecourse/courseversion
export function getDeclareCourseVersion (id) {
  return request({
    url: 'declarecourse/courseversion',
    method: 'get',
    params: {
      declareCourseId: id
    }
  })
}
// 获取学期列表 /term/list
export function getDeclareCourseTerm (id) {
  return request({
    url: 'term/list',
    method: 'get',
    params: {
      declareCourseId: id
    }
  })
}

//关联课件版本 /declarecourse/courseversion
export function addDeclareCourseVersion (data) {
  return request({
    url: 'declarecourse/courseversion',
    method: 'post',
    data
  })
}

//取消版本关联 /declarecourse/courseversion/{id}
export function deleteDeclareCourseVersion (id) {
  return request({
    url: 'declarecourse/courseversion/' + id,
    method: 'delete'
  })
}

// 获取课件的班课列表 /term/oclist
export function getDeclareCourseOcList (id) {
  return request({
    url: 'term/oclist',
    method: 'get',
    params: {
      declareCourseId: id
    }
  })
}

// 创建/修改学期 /term
export function saveDeclareCourseTerm (data) {
  return request({
    url: 'term',
    method: 'post',
    data
  })
}

//删除学期 /term/{id}
export function deleteDeclareCourseTerm (id) {
  return request({
    url: 'term/' + id,
    method: 'delete'
  })
}

//学期数据统计 /term/{termId}/statistics
export function getDeclareCourseTermStat (id) {
  return request({
    url: 'term/' + id + '/statistics',
    method: 'get'
  })
}

// 获取微信配置
export function getWxConfig () {
  return request({
    url: 'ulearning/jsconfig',
    method: 'post',
    data : {
      url: location.href.split("#")[0]
    }
  })
}

//获取二级站点网站信息 manager/systemManager/public/information?domain=wit&lang=zh
//学期数据统计 /term/{termId}/statistics
export function getSecondarySiteInfo (domain) {
  return request({
    url: 'manager/systemManager/public/information?domain=' + domain,
    method: 'get'
  })
}


// welink获取授权
export function welinkToken(params) {
  return request({
    url: `/weLink/weLinkLogin?code=${params.code}`,
    method: 'post',
    data: params
  })
}


// welink绑定账号
export function welinkBand(data) {
  return request({
    url: '/weLink/weLinkLoginBind',
    method: 'post',
    data: data
  })
}

// weLinkBind
export function weLinkBind(params) {
  return request({
    url: '/weLink/users/weLinkBind',
    method: 'post',
    params: params
  })
}

// 获取课程档案
export function archives(params) {
  return request({
    url: `/course/archives`,
    method: 'get',
    params: params
  })
}

// 获取公共的教学资料
export function teaResPublic(params) {
  return request({
    url: `/teachingResources/public`,
    method: 'get',
    params: params
  })
}

// 获取课件的教学资料
export function teachingResources(params) {
  return request({
    url: `/teachingResources`,
    method: 'get',
    params: params
  })
}

// 获取课件
export function getTextbookList(params) {
  return request({
    url: `/textbook/teacher/list`,
    method: 'get',
    params: params
  })
}

// 二级站点配置信息
export function getOrgMenuInfo(site) {
  return request({
    url: `/manager/systemManager/menu/information?domain=${site}`,
    method: 'get'
  })
}